module.exports = __webpack_public_path__ + "img/wx_qun.4329836d.png";